import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";

interface Props {
	label: string;
	tooltip: string;
}

/**
 * Field label with a trailing info-icon tooltip, for use in FormField /
 * FormSelectField. Matches the design-system label styling (the icon inherits
 * the label's color/size via the surrounding InputLabel).
 */
export const LabelWithTooltip: React.FC<Props> = ({ label, tooltip }) => (
	<span style={{ display: "flex", alignItems: "center", gap: 8 }}>
		<span>{label}</span>
		<Mui.Tooltip title={tooltip} placement="right" arrow>
			<Mui.IconButton
				size="small"
				// Inherit the label's color (#5f6368) rather than the primary/teal default
				color="inherit"
				style={{ padding: 0, width: 20, height: 20 }}
				onMouseDown={(e) => e.preventDefault()}
			>
				<Icons.Info size={16} />
			</Mui.IconButton>
		</Mui.Tooltip>
	</span>
);
